import React from 'react';
import { AlertTriangleIcon, DollarSignIcon, UserXIcon, AlertCircleIcon, PercentIcon } from 'lucide-react';
interface BudgetRulesProps {
  rulesJson: string;
}
export function BudgetRules({
  rulesJson
}: BudgetRulesProps) {
  let rules: Record<string, any> = {};
  try {
    rules = JSON.parse(rulesJson);
  } catch (error) {
    return <div className="p-3 bg-red-50 border border-red-200 rounded-md" data-id="element-8818">
        <div className="flex items-center" data-id="element-8819">
          <AlertTriangleIcon className="h-5 w-5 text-red-400 mr-2" data-id="element-8820" />
          <span className="text-sm text-red-700" data-id="element-8821">Invalid rules format</span>
        </div>
      </div>;
  }
  if (Object.keys(rules).length === 0) {
    return <div className="p-3 bg-gray-50 border border-gray-200 rounded-md" data-id="element-8822">
        <span className="text-sm text-gray-500" data-id="element-8823">No rules defined</span>
      </div>;
  }
  // Helper function to render rule value based on type
  const renderRuleValue = (key: string, value: any) => {
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    if (typeof value === 'number' && key.toLowerCase().includes('threshold')) {
      return `${value * 100}%`;
    }
    return value.toString();
  };
  // Helper function to get icon for rule
  const getRuleIcon = (key: string) => {
    const lowerKey = key.toLowerCase();
    if (lowerKey.includes('max') || lowerKey.includes('transaction') || lowerKey.includes('per')) {
      return <DollarSignIcon className="h-4 w-4 text-blue-500" data-id="element-8824" />;
    }
    if (lowerKey.includes('blacklist') || lowerKey.includes('vendor')) {
      return <UserXIcon className="h-4 w-4 text-red-500" data-id="element-8825" />;
    }
    if (lowerKey.includes('threshold') || lowerKey.includes('percent')) {
      return <PercentIcon className="h-4 w-4 text-yellow-500" data-id="element-8826" />;
    }
    if (lowerKey.includes('approval') || lowerKey.includes('required')) {
      return <AlertCircleIcon className="h-4 w-4 text-purple-500" data-id="element-8827" />;
    }
    return null;
  };
  // Format rule key for display
  const formatRuleKey = (key: string) => {
    // Convert camelCase to Title Case with spaces
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  };
  return <div className="border border-gray-200 rounded-md overflow-hidden" data-id="element-8828">
      <div className="divide-y divide-gray-200" data-id="element-8829">
        {Object.entries(rules).map(([key, value]) => <div key={key} className="px-4 py-3 flex items-start" data-id="element-8830">
            <div className="mr-3 mt-0.5" data-id="element-8831">{getRuleIcon(key)}</div>
            <div data-id="element-8832">
              <h6 className="text-xs font-medium text-gray-900" data-id="element-8833">
                {formatRuleKey(key)}
              </h6>
              <p className="mt-1 text-sm text-gray-500" data-id="element-8834">
                {renderRuleValue(key, value)}
              </p>
            </div>
          </div>)}
      </div>
    </div>;
}